import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SubRowContent from './RowContent';
import SectionTitle from '../../components/SectionTitle';

import { Stack } from '@mui/material';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const BasicInformation = (props: Props) => {
  const { disabled, register, watch, setValue, getValues } = props;

  const contents = [
    {
      label: '职业',
      element: (
        <Form.MuiTextField
          {...register('basic_information.occupation')}
          required={false}
          disabled={disabled}
          placeholder="输入"
        />
      ),
    },
    {
      label: '保险类型',
      element: (
        <Form.MuiRadioGroup
          i18nKey="HOME_CARE.INSURANCE_TYPE"
          values={[1, 2, 3]}
          disabled={disabled}
          defaultValue={getValues('basic_information.insurance_type')}
          onChange={v => setValue('basic_information.insurance_type', v)}
        />
      ),
    },
    {
      label: '居住情况',
      element: (
        <Stack direction="row" spacing={1}>
          <Form.MuiRadioGroup
            i18nKey="HOME_CARE.RESIDENCE"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('basic_information.residence')}
            onChange={v => setValue('basic_information.residence', v)}
            width="auto"
          />
          <Form.MuiTextField
            {...register('basic_information.residence_etc')}
            required={false}
            disabled={disabled}
            placeholder="Etc"
          />
        </Stack>
      ),
    },
    {
      label: '宗教',
      element: (
        <Form.MuiTextField
          {...register('basic_information.religion')}
          required={false}
          disabled={disabled}
          placeholder="输入"
        />
      ),
    },
    {
      label: '护理提供方',
      element: (
        <Form.MuiTextField
          {...register('basic_information.nursing_provider')}
          required={false}
          disabled={disabled}
          placeholder="输入"
        />
      ),
    },
    {
      label: '卫生情况',
      element: (
        <Stack direction="row" spacing={1}>
          <Form.MuiRadioGroup
            i18nKey="HOME_CARE.SANITARY"
            values={[1, 2]}
            disabled={disabled}
            defaultValue={getValues('basic_information.sanitary')}
            onChange={v => setValue('basic_information.sanitary', v)}
            width="auto"
          />
          <Form.MuiTextField
            {...register('basic_information.sanitary_notes')}
            required={false}
            disabled={disabled}
            placeholder="输入"
          />
        </Stack>
      ),
    },
    {
      label: '婚姻状况',
      element: (
        <Form.MuiTextField
          {...register('basic_information.marital_status')}
          required={false}
          disabled={disabled}
          placeholder="输入"
        />
      ),
    },
    {
      label: '既往病史',
      element: (
        <Form.MuiTextField
          {...register('basic_information.past_history')}
          required={false}
          disabled={disabled}
          placeholder="输入"
        />
      ),
    },
    {
      label: '安全情况',
      element: (
        <Stack direction="row" spacing={1}>
          <Form.MuiRadioGroup
            i18nKey="HOME_CARE.SAFETY"
            values={[1, 2]}
            disabled={disabled}
            defaultValue={getValues('basic_information.safety')}
            onChange={v => setValue('basic_information.safety', v)}
            width="auto"
          />
          <Form.MuiTextField
            {...register('basic_information.safety_notes')}
            required={false}
            disabled={disabled}
            placeholder="输入"
          />
        </Stack>
      ),
    },
  ];

  return (
    <>
      <SectionTitle title="基本信息" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => {
          if (label === '保险类型') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={0.8}
                  childrenRatio={3.1}
                >
                  {element}
                </SubRowContent>
              </>
            );
          } else if (label === '护理提供方') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={0.8}
                  childrenRatio={3.1}
                >
                  {element}
                </SubRowContent>
              </>
            );
          } else if (label === '婚姻状况') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={0.8}
                  childrenRatio={3.1}
                >
                  {element}
                </SubRowContent>
              </>
            );
          } else if (label === '既往病史') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={0.8}
                  childrenRatio={3.1}
                >
                  {element}
                </SubRowContent>
              </>
            );
          }
          return (
            <>
              <RowContent title={label} titleRatio={0.8} childrenRatio={3.1}>
                {element}
              </RowContent>
            </>
          );
        })}
      </RowContainer>
    </>
  );
};

export default BasicInformation;
